import { all, fork } from 'redux-saga/effects';

import { effects as shipmentEffects } from 'state/direct-order-recurring/shipments';
import { effects as insuranceEffects } from 'state/direct-order-recurring/insurance';

export default function* directOrderRecurringSaga() {
  yield all([fork(insuranceEffects)]);
  yield all([fork(shipmentEffects)]);
}
